import React from 'react';
import type { ComponentProps } from 'react';
import type { Optional } from '@/types/types'
import { classes } from '@/util/component-utils'
import styles from './icons.module.css';

// Offsets of the SVG relative to its container element (in px)
export type Position = {
    x: number,
    y: number
}

// Size of the SVG without altering its container element (in px)
export type Size = {
    width: number,
    height: number
}

export interface IconProps extends ComponentProps<"div"> {
    size?: Size;
    position?: Position,
    fill?: string;
    stroke?: string;
}

const pxDimension = (dimension?: number): Optional<string> => {
    if (!dimension) {
        return;
    }
    return `${dimension}px`;
}

export const createSvgIcon = (svg: React.JSX.Element, props: IconProps) =>  {
    const innerStyle = {
        width: pxDimension(props.size?.width) ?? "24px",
        height: pxDimension(props.size?.height) ?? "24px",
        left: pxDimension(props.position?.x),
        top: pxDimension(props.position?.y),
        fill: props.fill,
        stroke: props.stroke
    }

    return (
        <div className={classes(props.className, styles.outer)}>
            <div className={styles.inner} style={innerStyle}>
                {svg}
            </div>
        </div>
    );
}